async function copyTextAndSendToApp(text) {
  navigator.clipboard.writeText(text);

  window?.ReactNativeWebView?.postMessage(JSON.stringify({ copy: text }));
}

export { copyTextAndSendToApp };
